import moment from 'moment';
import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import * as rdrLocales from 'react-date-range/src/locale';
import { DateUtils } from 'react-day-picker';
import 'react-day-picker/lib/style.css';
import { connect } from 'react-redux';
import Switch from 'react-switch';
import * as QuotationsActions from '../redux/QuotationsActions';
import {
  calendarDayToUtc,
  utcToCalendarDay,
} from '../../../libCustom/travelDates';

class datesQuotation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openDateDisabled: false,
      days: 0,
      dateRange: {
        selection: {
          startDate: new Date(),
          endDate: null,
          key: 'selection',
        },
      },
      from: undefined,
      to: undefined,
    };
    this.handleDayClick = this.handleDayClick.bind(this);
    this.handleResetClick = this.handleResetClick.bind(this);
  }

  componentWillMount() {
    let startDate = moment(this.props.Quotations.dates.departureDate);
    let endDate = moment(this.props.Quotations.dates.returnDate);

    const diff = endDate.diff(startDate, 'days');

    this.setState({
      days: diff,
      openDateDisabled: this.props.Quotations.dates.openDate,
    });
  }

  handleChange(id, checked) {
    if (checked === true) {
      this.setState({
        openDateDisabled: true,
      });
      this.props.dispatch(
        QuotationsActions.onChange(['dates', 'returnDate'], calendarDayToUtc(moment()))
      );
      this.props.dispatch(
        QuotationsActions.onChange(['dates', 'departureDate'], calendarDayToUtc(moment()))
      );
    } else {
      this.setState({
        openDateDisabled: false,
        days: 0,
      });
    }
    this.props.dispatch(QuotationsActions.onChange(['dates', id], checked));
  }

  handleRangeChange = (payload) => {
    let endDate = calendarDayToUtc(payload.selection.endDate);
    let startDate = calendarDayToUtc(payload.selection.startDate);

    const diff = endDate.diff(startDate, 'days');

    this.props.dispatch(
      QuotationsActions.onChange(['dates', 'returnDate'], endDate)
    );
    this.props.dispatch(
      QuotationsActions.onChange(['dates', 'departureDate'], startDate)
    );
    this.props.dispatch(
      QuotationsActions.onChange(['dates', 'duration'], diff)
    );

    this.setState({
      days: diff,
    });
  };

  static defaultProps = {
    numberOfMonths: 2,
  };

  handleDayClick(day) {
    const range = DateUtils.addDayToRange(day, this.state);
    this.setState(range);
    this.props.dispatch(QuotationsActions.onChange(['dates', 'range'], range));
  }

  handleResetClick() {
    this.setState(this.getInitialState());
  }

  render() {
    const { Quotations } = this.props;

    return (
      <div>
        <Row>
          <Col md={3}>
            <div className="form-group">
              <label htmlFor="openDate">Fecha abierta de cotización</label>
            </div>
          </Col>
          <Col md={2}>
            <div className="form-group">
              <Switch
                id="openDate"
                checked={Quotations.dates.openDate}
                onChange={(checked) => this.handleChange('openDate', checked)}
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            {!this.state.openDateDisabled ? (
              <div>
                <DateRange
                  onChange={this.handleRangeChange}
                  moveRangeOnFirstSelection={false}
                  months={2}
                  direction="horizontal"
                  locale={rdrLocales['es']}
                  minDate={new Date()}
                  ranges={[
                    {
                      startDate:
                        Quotations.dates.departureDate !== '' &&
                          Quotations.dates.departureDate !== undefined
                          ? utcToCalendarDay(Quotations.dates.departureDate)
                          : moment(),
                      endDate:
                        Quotations.dates.returnDate !== '' &&
                          Quotations.dates.returnDate !== undefined
                          ? utcToCalendarDay(Quotations.dates.returnDate)
                          : moment(),
                      key: 'selection',
                    },
                  ]}
                  className={'PreviewArea'}
                />

                <input
                  style={{
                    height: 1,
                    padding: 0,
                    margin: 0,
                    border: 0,
                    color: 'white',
                  }}
                  required
                  type="text"
                  id="userIdHidden"
                  value={Quotations.dates.departureDate}
                  readOnly={true}
                />
              </div>
            ) : null}
          </Col>
        </Row>

        <Row>&nbsp;</Row>
        {!this.state.openDateDisabled ? (
          <Row>
            <Col md={3}>
              <div className="form-group">
                <label htmlFor="duration">Duración (noches)</label>
                <input
                  id="activityInput"
                  className="form-control"
                  rows="1"
                  value={this.state.days}
                  disabled
                  name="body"
                  type="number"
                />
              </div>
            </Col>
          </Row>
        ) : null}
      </div>
    );
  }
}

export default connect((state) => ({ Quotations: state.Quotations }))(
  datesQuotation
);



// WEBPACK FOOTER //
// ./src/views/Quotations/cards/datesQuotation.js